import apiClient from './apiClient'

export const getSiteConfig = async () => {
  const response = await apiClient.get('/site-config/')
  return response.data
}

export const getPublicSiteConfig = getSiteConfig

export const updateSiteConfig = async (configData) => {
  const current = await getSiteConfig()
  const id = current.id || 1
  const response = await apiClient.patch(`/site-config/${id}/`, configData)
  return response.data
}

export const getDistributorDiscount = async () => {
  const response = await apiClient.get('/distributor-discount/')
  return response.data
}

export const updateDistributorDiscount = async (discountPercentage) => {
  const response = await apiClient.post('/distributor-discount/update/', {
    discount_percentage: discountPercentage,
  })
  return response.data
}

export const getCurrentDollarRate = async () => {
  const response = await apiClient.get('/dollar-rate/current/')
  return response.data
}
